import {
  Box,
  IconButton,
  Paper,
  Stack,
  Theme,
  Typography,
} from '@mui/material';
import { CustomContentProps, VariantType, closeSnackbar } from 'notistack';
import { forwardRef } from 'react';
import { Clear } from '@mui/icons-material';

const getColor = (t: Theme, variant: VariantType): string => {
  const defaultColor = t.palette.info.main;
  const colors: Record<VariantType, string> = {
    success: t.palette.success.main,
    error: t.palette.error.main,
    warning: t.palette.warning.main,
    info: defaultColor,
    default: defaultColor,
  };

  return colors[variant] || defaultColor;
};

export const WatchDutySnackbarContent = forwardRef<
  HTMLDivElement,
  CustomContentProps
>((props, ref): JSX.Element => {
  const {
    action,
    autoHideDuration,
    message,
    variant,
    iconVariant,
    hideIconVariant,
    id,
    style,
    persist,
  } = props;

  const icon = iconVariant[variant];
  const actionComponent = typeof action === 'function' ? action(id) : action;
  const showClearButton =
    persist || (autoHideDuration && autoHideDuration > 2000);

  return (
    <Paper ref={ref} elevation={3} sx={{ overflow: 'hidden' }} style={style}>
      <Stack
        direction="row"
        spacing={1}
        sx={{ justifyContent: 'space-between' }}
      >
        {!hideIconVariant && icon && (
          <Box
            sx={(t) => ({
              background: getColor(t, variant),
              paddingX: 1,
              color: t.palette.common.white,
            })}
            alignContent="center"
          >
            {icon}
          </Box>
        )}
        <Stack sx={{ padding: 1, width: '100%', justifyContent: 'center' }}>
          <Typography variant="body2">{message}</Typography>
          {action && <Box sx={{ marginTop: 1 }}>{actionComponent}</Box>}
        </Stack>
        {showClearButton && (
          <Box alignContent="center">
            <IconButton onClick={() => closeSnackbar(id)}>
              <Clear fontSize="small" />
            </IconButton>
          </Box>
        )}
      </Stack>
    </Paper>
  );
});

WatchDutySnackbarContent.displayName = 'WatchDutySnackbarContent';
